<template>
  <section class="l-section p-configurator__header">
    <h2 class="headline">
    <p class="en">{{ title.main }}</p>
    <p class="jp">{{ title.sub }}</p>
    </h2>
  </section>
</template>

<script>
export default {
  props: ["title"],
};
</script>
<style scoped></style>
